import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/vsts/work/1/s/app/[brands]/seo/menu/[...slug]/NutritionInfoButton.jsx");
;
import(/* webpackMode: "eager" */ "/home/vsts/work/1/s/node_modules/next/dist/client/image-component.js");
